import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));

const Minimal = Loadable(lazy(() => import('../views/dashboards/Minimal')));
const Dash = Loadable(lazy(() => import('../views/dashboards/Dash')));
const Analytical = Loadable(lazy(() => import('../views/dashboards/Analytical')));
const Demographical = Loadable(lazy(() => import('../views/dashboards/Demographical')));
const Modern = Loadable(lazy(() => import('../views/dashboards/Modern')));

const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Chat = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/CalendarApp')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
const Shop = Loadable(lazy(() => import('../views/apps/ecommerce/Shop')));
const ShopDetail = Loadable(lazy(() => import('../views/apps/ecommerce/ShopDetail')));
const Treeview = Loadable(lazy(() => import('../views/apps/treeview/TreeView')));
const TicketList = Loadable(lazy(() => import('../views/apps/ticket/TicketList')));
const TicketDetail = Loadable(lazy(() => import('../views/apps/ticket/TicketDetail')));

const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')));
const Badges = Loadable(lazy(() => import('../views/ui/Badges')));
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')));
const Cards = Loadable(lazy(() => import('../views/ui/Cards')));
const Grid = Loadable(lazy(() => import('../views/ui/Grid')));
const Tables = Loadable(lazy(() => import('../views/ui/Tables')));
const Forms = Loadable(lazy(() => import('../views/ui/Forms')));
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')));
const Dropdowns = Loadable(lazy(() => import('../views/ui/DropDown')));
const BtnGroup = Loadable(lazy(() => import('../views/ui/BtnGroup')));
const Collapse = Loadable(lazy(() => import('../views/ui/Collapse')));
const ListGroup = Loadable(lazy(() => import('../views/ui/ListGroup')));
const Modal = Loadable(lazy(() => import('../views/ui/Modal')));
const Navbar = Loadable(lazy(() => import('../views/ui/Navbar')));
const Nav = Loadable(lazy(() => import('../views/ui/Nav')));
const Pagination = Loadable(lazy(() => import('../views/ui/Pagination')));
const Popover = Loadable(lazy(() => import('../views/ui/Popover')));
const Progress = Loadable(lazy(() => import('../views/ui/Progress')));
const Spinner = Loadable(lazy(() => import('../views/ui/Spinner')));
const Tabs = Loadable(lazy(() => import('../views/ui/Tabs')));
const Toasts = Loadable(lazy(() => import('../views/ui/Toasts')));
const Tooltip = Loadable(lazy(() => import('../views/ui/Tooltip')));

const FormBasic = Loadable(lazy(() => import('../views/form-layouts/FormBasic')));
const FormGrid = Loadable(lazy(() => import('../views/form-layouts/FormGrid')));
const FormGroup = Loadable(lazy(() => import('../views/form-layouts/FormGroup')));
const FormInput = Loadable(lazy(() => import('../views/form-layouts/FormInput')));

const Datepicker = Loadable(lazy(() => import('../views/form-pickers/DateTimePicker')));
const TagSelect = Loadable(lazy(() => import('../views/form-pickers/TagSelect')));

const FormValidate = Loadable(lazy(() => import('../views/form-validation/FormValidation')));
const FormSteps = Loadable(lazy(() => import('../views/form-steps/Steps')));
const FormEditor = Loadable(lazy(() => import('../views/form-editor/FormEditor')));

const Basictable = Loadable(lazy(() => import('../views/tables/TableBasic')));
const CustomReactTable = Loadable(lazy(() => import('../views/tables/CustomReactTable')));
const ReactBootstrapTable = Loadable(lazy(() => import('../views/tables/ReactBootstrapTable')));

const ApexCharts = Loadable(lazy(() => import('../views/charts/ApexCharts')));
const ChartJs = Loadable(lazy(() => import('../views/charts/ChartJs')));

const StarterKit = Loadable(lazy(() => import('../views/sample-pages/StarterKit')));
const Profile = Loadable(lazy(() => import('../views/sample-pages/Profile')));
const Gallery = Loadable(lazy(() => import('../views/sample-pages/Gallery')));
const SearchResult = Loadable(lazy(() => import('../views/sample-pages/SearchResult')));
const HelperClass = Loadable(lazy(() => import('../views/sample-pages/HelperClass')));

const Bootstrap = Loadable(lazy(() => import('../views/icons/Bootstrap')));
const Feather = Loadable(lazy(() => import('../views/icons/Feather')));

const CustomVectorMap = Loadable(lazy(() => import('../views/maps/CustomVectorMap')));

const Widget = Loadable(lazy(() => import('../views/widget/Widget')));

const CASL = Loadable(lazy(() => import('../views/apps/accessControlCASL/AccessControl')));

const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));
const ChangePassword = Loadable(lazy(() => import('../views/auth/ChangePassword')));

const MasterRoleTable = Loadable(lazy(() => import('../views/master/MasterRoleTable')));
const MasterUser = Loadable(lazy(() => import('../views/master/MasterUser')));
const MasterDepartment = Loadable(lazy(() => import('../views/master/MasterDepartment')));
const MasterCompany = Loadable(lazy(() => import('../views/master/MasterCompany')));
const MasterSetting = Loadable(lazy(() => import('../views/master/MasterSetting')));
const MasterPaymentMethod = Loadable(lazy(() => import('../views/master/MasterPaymentMethod')));
const MasterCategoryPatient = Loadable(lazy(() => import('../views/master/MasterCategoryPatient')));
const MasterPatient = Loadable(lazy(() => import('../views/master/MasterPatient')));
const MasterPolyclinic = Loadable(lazy(() => import('../views/master/MasterPolyclinic')));
const MasterInsurance = Loadable(lazy(() => import('../views/master/MasterInsurance')));
const MasterSpecialization = Loadable(lazy(() => import('../views/master/MasterSpecialization')));
const MasterDoctor = Loadable(lazy(() => import('../views/master/MasterDoctor')));
const MasterSupplier = Loadable(lazy(() => import('../views/master/MasterSupplier')));
const MasterUnitItem = Loadable(lazy(() => import('../views/master/MasterUnitItem')));
const MasterCategoryItem = Loadable(lazy(() => import('../views/master/MasterCategoryItem')));
const MasterItem = Loadable(lazy(() => import('../views/master/MasterItem')));
const MasterCounter = Loadable(lazy(() => import('../views/master/MasterCounter')));
const MasterTreatment = Loadable(lazy(() => import('../views/master/MasterTreatment')));
const MasterDiagnosis = Loadable(lazy(() => import('../views/master/MasterDiagnosis')));

const Pharmacy = Loadable(lazy(() => import('../views/pos/Pharmacy')));
const PharmacyList = Loadable(lazy(() => import('../views/pos/PharmacyList')));

const PurchaseInvoice = Loadable(lazy(() => import('../views/transaction/PurchaseInvoice')));

const PatientDetailView = Loadable(lazy(() => import('../views/master/patient/PatientDetailView')));
const VisitPatientDetail = Loadable(lazy(() => import('../views/master/patient/VisitPatientDetail')));

const PrepareQueueInput = Loadable(lazy(() => import('../views/administration/queue/PrepareQueueInput')));
const Queue = Loadable(lazy(() => import('../views/administration/queue/Queue')));
const RegistrationQueue = Loadable(lazy(() => import('../views/administration/queue/RegistrationQueueInput')));
const AddRegistrationPatientInput = Loadable(lazy(() => import('../views/administration/queue/AddRegistrationPatientInput')));

const OutpatientRegistrationGridList = Loadable(lazy(() => import('../views/administration/outpatient-registration/OutpatientRegistrationGridList')));
const OutpatientRegistrationInput = Loadable(lazy(() => import('../views/administration/outpatient-registration/OutpatientRegistrationInput')));
const OutpatientRegistrationEdit = Loadable(lazy(() => import('../views/administration/outpatient-registration/OutpatientRegistrationEdit')));

const OutpatientGridList = Loadable(lazy(() => import('../views/services/outpatient/OutpatientGridList')));

const InspectionBillGridList = Loadable(lazy(() => import('../views/transaction/inspection-bill/InspectionBillGridList')));
const InspectionBillView = Loadable(lazy(() => import('../views/transaction/inspection-bill/InspectionBillView')));

const MedicationBillGridList = Loadable(lazy(() => import('../views/transaction/medication-bill/MedicationBillGridList')));
const MedicationBillView = Loadable(lazy(() => import('../views/transaction/medication-bill/MedicationBillView')));

const LabBillGridList = Loadable(lazy(() => import('../views/transaction/lab-bill/LabBillGridList')));
const LabBillView = Loadable(lazy(() => import('../views/transaction/lab-bill/LabBillView')));

const TreatmentBillGridList = Loadable(lazy(() => import('../views/transaction/treatment-bill/TreatmentBillGridList')));
const TreatmentBillView = Loadable(lazy(() => import('../views/transaction/treatment-bill/TreatmentBillView')));

const ThemeRoutes = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', name: 'Home', element: <Navigate to="/administration/queues" />},
      { path: '/change-password', name: 'ChangePassword', element: <ChangePassword />},
      { path: '/master/role', name: 'MasterRoleTable', element: <MasterRoleTable/>},
      { path: '/master/user', name: 'MasterUser', element: <MasterUser/>},
      { path: '/master/department', name: 'MasterDepartment', element: <MasterDepartment/>},
      { path: '/master/company', name: 'MasterCompany', element: <MasterCompany/>},
      { path: '/master/setting', name: 'MasterSetting', element: <MasterSetting/>},
      { path: '/master/payment-method', name: 'MasterPaymentMethod', element: <MasterPaymentMethod/> },
      { path: '/master/category-patient', name: 'MasterCategoryPatient', element: <MasterCategoryPatient/> },
      { path: '/master/patient', name: 'MasterPatient', element: <MasterPatient/>},
      { path: '/master/doctor', name: 'MasterDoctor', element: <MasterDoctor/>},
      { path: '/master/polyclinic', name: 'MasterPolyclinic', element: <MasterPolyclinic/>},
      { path: '/master/insurance', name: 'MasterInsurance', element: <MasterInsurance/>},
      { path: '/master/specialization', name: 'MasterSpecialization', element: <MasterSpecialization/>},
      { path: '/master/supplier', name: 'MasterSupplier', element: <MasterSupplier/>},
      { path: '/master/unit-item', name: 'MasterUnitItem', element: <MasterUnitItem/>},
      { path: '/master/category-item', name: 'MasterCategoryItem', element: <MasterCategoryItem/>},
      { path: '/master/item', name: 'MasterItem', element: <MasterItem/>},
      { path: '/master/counter', name: 'MasterCounter', element: <MasterCounter/>},
      { path: '/master/treatment', name: 'MasterTreatment', element: <MasterTreatment/>},
      { path: '/master/diagnosis', name: 'MasterDiagnosis', element: <MasterDiagnosis/>},
      { path: '/transaction/purchase-invoice', name: 'PurchaseInvoice', element: <PurchaseInvoice/>},
      { path: '/pharmacy', name: 'Pharmacy', exact: true, element: <Pharmacy /> },
      { path: '/pharmacy/list', name: 'pharmacy-list', exact: true, element: <PharmacyList /> },
      { path : '/administration/patient/detail/:id', name: 'PatientDetailView', element: <PatientDetailView/>},
      { path : '/master/patient/detail/:id', name: 'PatientDetailView', element: <PatientDetailView/>},
      { path : '/master/patient/visit-detail/:id', name: 'VisitPatientDetail', element: <VisitPatientDetail/>},
      { path: '/administration/prepare-queue/input', name: 'PrepareQueue', element: <PrepareQueueInput/>},
      { path: '/administration/queues', name: 'Queue', element: <Queue/>},
      { path: '/administration/registration', name: 'RegistrationQueue', element: <RegistrationQueue/>},
      { path: '/administration/registration/add-patient', name: 'AddRegistrationPatient', element: <AddRegistrationPatientInput/>},
      { path: '/administration/registration/outpatient-list', name: 'OutpatientRegistrationGridList', element: <OutpatientRegistrationGridList/>},
      { path: '/administration/registration/outpatient-list/add', name: 'OutpatientRegistrationInput', element: <OutpatientRegistrationInput/>},
      { path: '/administration/registration/outpatient-list/edit/:id', name: 'OutpatientRegistrationEdit', element: <OutpatientRegistrationEdit/>},
      { path: '/services/outpatient', name: 'OutpatientGridList', element: <OutpatientGridList/>},
      { path: '/transaction/inspection-bill', name: 'InspectionBillGridList', element: <InspectionBillGridList/>},
      { path: '/transaction/inspection-bill/view/:id', name: 'InspectionBillView', element: <InspectionBillView/>},
      { path: '/transaction/medication-bill', name: 'MedicationBillGridList', element: <MedicationBillGridList/>},
      { path: '/transaction/medication-bill/view/:id', name: 'MedicationBillView', element: <MedicationBillView/>},
      { path: '/transaction/lab-bill', name: 'LabBillGridList', element: <LabBillGridList/>},
      { path: '/transaction/lab-bill/view/:id', name: 'LabBillView', element: <LabBillView/>},
      { path: '/transaction/treatment-bill/view/:id', name: 'TreatmentBillView', element: <TreatmentBillView/>},
      { path: '/transaction/treatment-bill', name: 'TreatmentBillGridList', element: <TreatmentBillGridList/>},
      { path: '/dashboards/minimal', name: 'Minimal', exact: true, element: <Minimal />},
      { path: '/dashboards', name: 'Dashboard', exact: true, element: <Dash />},
      { path: '/dashboards/analytical', name: 'Analytical', exact: true, element: <Analytical /> },
      { path: '/dashboards/demographical', name: 'Demographical', exact: true, element: <Demographical />},
      { path: '/dashboards/modern', name: 'Modern', exact: true, element: <Modern />},
      { path: '/apps/notes', name: 'notes', exact: true, element: <Notes />},
      { path: '/apps/chat', name: 'chat', exact: true, element: <Chat />},
      { path: '/apps/contacts', name: 'contacts', exact: true, element: <Contacts />},
      { path: '/apps/calendar', name: 'calendar', exact: true, element: <Calendar />},
      { path: '/apps/email', name: 'email', exact: true, element: <Email />},
      { path: '/ecom/shop', name: 'email', exact: true, element: <Shop />},
      { path: '/ecom/shopdetail', name: 'email', exact: true, element: <ShopDetail />},
      { path: '/tickt/ticket-list', name: 'ticket list', exact: true, element: <TicketList />},
      { path: '/tickt/ticket-detail', name: 'ticket detail', exact: true, element: <TicketDetail />},
      { path: '/apps/treeview', name: 'email', exact: true, element: <Treeview />},
      { path: '/ui/alerts', name: 'alerts', exact: true, element: <Alerts />},
      { path: '/ui/badges', name: 'badges', exact: true, element: <Badges />},
      { path: '/ui/buttons', name: 'buttons', exact: true, element: <Buttons />},
      { path: '/ui/cards', name: 'cards', exact: true, element: <Cards />},
      { path: '/ui/grid', name: 'grid', exact: true, element: <Grid />},
      { path: '/ui/table', name: 'table', exact: true, element: <Tables />},
      { path: '/ui/forms', name: 'forms', exact: true, element: <Forms />},
      { path: '/ui/breadcrumbs', name: 'breadcrumbs', exact: true, element: <Breadcrumbs /> },
      { path: '/ui/dropdown', name: 'dropdown', exact: true, element: <Dropdowns /> },
      { path: '/ui/button-group', name: 'button group', exact: true, element: <BtnGroup /> },
      { path: '/ui/collapse', name: 'collapse', exact: true, element: <Collapse /> },
      { path: '/ui/list-group', name: 'list-group', exact: true, element: <ListGroup /> },
      { path: '/ui/modal', name: 'modal', exact: true, element: <Modal /> },
      { path: '/ui/navbar', name: 'navbar', exact: true, element: <Navbar /> },
      { path: '/ui/nav', name: 'nav', exact: true, element: <Nav /> },
      { path: '/ui/pagination', name: 'pagination', exact: true, element: <Pagination /> },
      { path: '/ui/popover', name: 'popover', exact: true, element: <Popover /> },
      { path: '/ui/progress', name: 'progress', exact: true, element: <Progress /> },
      { path: '/ui/spinner', name: 'spinner', exact: true, element: <Spinner /> },
      { path: '/ui/tabs', name: 'tabs', exact: true, element: <Tabs /> },
      { path: '/ui/toasts', name: 'toasts', exact: true, element: <Toasts /> },
      { path: '/ui/tooltip', name: 'tooltip', exact: true, element: <Tooltip /> },
      { path: '/form-layout/form-basic', name: 'form-basic', exact: true, element: <FormBasic /> },
      { path: '/form-layout/form-grid', name: 'form-grid', exact: true, element: <FormGrid /> },
      { path: '/form-layout/form-group', name: 'form-group', exact: true, element: <FormGroup /> },
      { path: '/form-layout/form-input', name: 'form-input', exact: true, element: <FormInput /> },
      { path: '/form-pickers/datepicker', name: 'datepicker', exact: true, element: <Datepicker /> },
      { path: '/form-pickers/tag-select', name: 'tag-select', exact: true, element: <TagSelect /> },
      { path: '/form-validation', name: 'form-validation', exact: true, element: <FormValidate /> },
      { path: '/form-steps', name: 'form-steps', exact: true, element: <FormSteps /> },
      { path: '/form-editor', name: 'form-editor', exact: true, element: <FormEditor /> },
      { path: '/tables/basic-table', name: 'basic-table', exact: true, element: <Basictable /> },
      { path: '/tables/react-table', name: 'react-table', exact: true, element: <CustomReactTable /> },
      { path: '/tables/data-table', name: 'data-table', exact: true, element: <ReactBootstrapTable /> },
      { path: '/charts/apex', name: 'apex', exact: true, element: <ApexCharts /> },
      { path: '/charts/chartjs', name: 'chartjs', exact: true, element: <ChartJs /> },
      { path: '/sample-pages/profile', name: 'profile', exact: true, element: <Profile /> },
      { path: '/sample-pages/helper-class', name: 'helper-class', exact: true, element: <HelperClass /> },
      { path: '/sample-pages/starterkit', name: 'starterkit', exact: true, element: <StarterKit /> },
      { path: '/sample-pages/gallery', name: 'gallery', exact: true, element: <Gallery /> },
      { path: '/sample-pages/search-result', name: 'search-result', exact: true, element: <SearchResult /> },
      { path: '/icons/bootstrap', name: 'bootstrap', exact: true, element: <Bootstrap /> },
      { path: '/icons/feather', name: 'feather', exact: true, element: <Feather /> },
      { path: '/map/vector', name: 'vector', exact: true, element: <CustomVectorMap /> },
      { path: '/widget', name: 'widget', exact: true, element: <Widget /> },
      { path: '/casl', name: 'casl', exact: true, element: <CASL /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/print',
    element: <BlankLayout />,
    children: [
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'loginformik', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
    ],
  },
];

export default ThemeRoutes;